import { cn } from '@/lib/utils';

interface UrgencyBadgeProps {
  readonly score: number;
  readonly className?: string;
}

export function getUrgencyConfig(score: number) {
  if (score >= 9) return { label: 'CRITICAL', className: 'urgency-critical', color: 'compliance-critical', borderColor: 'border-l-compliance-critical' };
  if (score >= 7) return { label: 'HIGH', className: 'urgency-high', color: 'compliance-high', borderColor: 'border-l-compliance-high' };
  if (score >= 5) return { label: 'MEDIUM', className: 'urgency-medium', color: 'compliance-medium', borderColor: 'border-l-compliance-medium' };
  return { label: 'LOW', className: 'urgency-low', color: 'compliance-low', borderColor: 'border-l-compliance-low' };
}

export function UrgencyBadge({ score, className }: UrgencyBadgeProps) {
  const { label, className: urgencyClass } = getUrgencyConfig(score);

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-0.5 text-xs font-semibold',
        urgencyClass,
        className,
      )}
    >
      {label}
    </span>
  );
}
